import styled from"@emotion/styled";import Divider from"@wp/src/components/common/divider";import{mediaQuery}from"@wp/src/components/common/grid";export const DashDivider=styled(Divider)`
  border: 1px dashed ${props=>props.theme.colors.neutral300};
  margin: 0;
`;export const InsightPopoverContent=styled.div`
  background-color: ${props=>props.theme.colors.neutral900};
  color: white;
  border-radius: 4px;
  max-width: 240px;
  font-weight: 400;
  font-size: 12px;

  > p {
    margin: 0;
  }
`;export const PopoverHeading=styled.div`
  color: white;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 2px;
`;export const ImportanceAndScoreContainer=styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: nowrap;
  & > :not(:last-child) {
    margin-right: 16px;
  }
`;export const InsightsContainer=styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-width: 750px;
  align-items: stretch;
  justify-content: center;
  ${mediaQuery({width:["100%","100%","100%","80%","70%","60%"]})}
`;